import {mem1, mem2, mem3, mem4, mem5, mem6,mem7, mem8, mem9,mem10, mem11, mem12,mem13, mem14, mem15,mem16, mem17  } from './importIMG';

const memsData = [
    {
        title: "Szalone życie",
        upvotes: 6,
        downvotes: 5,
        imageUrl: mem1,
    },
    {
        title: "Download",
        upvotes: 3,
        downvotes: 0,
        imageUrl: mem2,
    },
    {
        title: "Wieszcz narodu",
        upvotes: 13,
        downvotes: 8,
        imageUrl: mem3,
    },
    {
        title: "Need for speed",
        upvotes: 7,
        downvotes: 9,
        imageUrl: mem4,
    }, {
        title: "800+ na pazurki",
        upvotes: 1,
        downvotes: 2,
        imageUrl: mem5,
    }, {
        title: "Ogórki za darmo",
        upvotes: 2,
        downvotes: 1,
        imageUrl: mem6,
    }, {
        title: "Dawaj te skórke",
        upvotes: 9,
        downvotes: 3,
        imageUrl: mem7,
    }, {
        title: "Passeratti",
        upvotes: 9,
        downvotes: 8,
        imageUrl: mem8,
    }, {
        title: "Bombelki",
        upvotes: 0,
        downvotes: 4,
        imageUrl: mem9,
    }, {
        title: "Dj MedicClub",
        upvotes: 15,
        downvotes: 0,
        imageUrl: mem10,
    },
    {
        title: "Oregano",
        upvotes: 12,
        downvotes: 8,
        imageUrl: mem11,
    }, {
        title: "Wyższa matematyka",
        upvotes: 1,
        downvotes: 3,
        imageUrl: mem12,
    }, {
        title: "A to w porządku",
        upvotes: 8,
        downvotes: 4,
        imageUrl: mem13,
    }, {
        title: "Mickiewicz",
        upvotes:13,
        downvotes: 2,
        imageUrl: mem14,
    }, {
        title: "Zdążyłem zrobić kolację, ożenić się i mieć dzieci",
        upvotes: 2,
        downvotes: 2,
        imageUrl: mem15,
    }, {
        title: "Dobre, bo wegańskie",
        upvotes: 22,
        downvotes: 17,
        imageUrl: mem16,
    }, {
        title: "Kadry",
        upvotes: 22,
        downvotes: 17,
        imageUrl: mem17,
    },
    
];

export default memsData;